import { Stack } from "@mantine/core";
import { useHasPermission } from "../../../hooks/useHasPermission";
import {
  useSystemEmailModeDialog,
  useSystemEmailModeConfirmModel,
  useSystemEmailModeMutation,
} from "../../../hooks/admin/useSystemEmailModeControl";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { NonHoldableEmailInfo } from "./NonHoldableEmailInfo";
import { SystemEmailModeConfirmModal } from "./SystemEmailModeConfirmModal";
import { SystemEmailModeSelector } from "./SystemEmailModeSelector";

interface Props {
  entry: SystemEmailRegistryEntry;
}

export function SystemEmailModeControl({ entry }: Props) {
  const dialog = useSystemEmailModeDialog();
  const update = useSystemEmailModeMutation(entry, dialog.mode, dialog.close);
  const canManage = useHasPermission("system_emails.manage");
  const model = useSystemEmailModeConfirmModel(entry, dialog, update);
  return (
    <Stack gap="xs">
      {entry.holdable ? (
        <SystemEmailModeSelector
          disabled={!canManage}
          entry={entry}
          onOpen={dialog.open}
          onReset={update.mutation.reset}
        />
      ) : (
        <NonHoldableEmailInfo />
      )}
      <SystemEmailModeConfirmModal model={model} />
    </Stack>
  );
}
